/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterTaxState } from "./type";

const INITIAL_STATE: FilterTaxState = {
  filters: {
    search: "",
    tax_type_request: "",
    type: "",
    created_at: "",
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

type FilterKeys = keyof FilterTaxState["filters"];

const filterTaxSlice = createSlice({
  name: "filters",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action: PayloadAction<{ key: FilterKeys; value: any }>) {
      state.filters[action.payload.key] = action.payload.value;
    },
    resetFilters(state) {
      state.filters = INITIAL_STATE.filters;
    },
    setPagination(
      state,
      action: PayloadAction<{ page: number; perPage: number }>
    ) {
      state.filters.meta = action.payload;
    },
  },
});

export const { setFilter, resetFilters, setPagination } =
  filterTaxSlice.actions;
export default filterTaxSlice.reducer;
